import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../store/hooks/store.hooks";
import { liveAgentSelector } from "./liveAgent.selector";
interface LiveAgentButton {
  buttonDiv: HTMLDivElement;
  chat: {
    width: string;
    height: string;
    position: string;
    className: string;
    id: string;
    [key: string]: any; // Для додаткових властивостей, якщо вони з'являться
  };
  dateChanged: string;
  elementId: string;
  id: string;
  note: string;
  onCloseCallBack: () => void;
  restartCallback: () => void;
}
// Визначаємо типи для глобального об'єкта LiveAgent
interface LiveAgent {
  createButton: (id: string, element: HTMLElement | null) => LiveAgentButton;
  //   startChat: (id: string) => void;
  //   onClick: () => void;
  setUserDetails: (
    email?: string,
    firstName?: string,
    lastName?: string,
    phone?: string
  ) => void;
  addUserDetail: (field: string, value: string | number) => void;
  addContactField: (key: string, value: string | number) => void;
  clearAllUserDetails: () => void;
}

declare global {
  interface Window {
    LiveAgent?: LiveAgent;
  }
}

interface LiveAgentChatWidgetProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
//@
const LiveAgentChatWidget: React.FC<LiveAgentChatWidgetProps> = ({
  open,
  setOpen,
}) => {
  //   const [isChatTriggered, setIsChatTriggered] = useState(false);
  const { email, phone, id, auth, firstName, lastName } =
    useAppSelector(liveAgentSelector);
  // Функція для ініціалізації чату
  const [button, setButton] = useState<any>();
  // Передаємо initializeChat через onOpenChat
  useEffect(() => {
    console.log(button, open);
    if (open && button) {
      button.buttonDiv.click();
    } else if (open && !button) {
      const script = document.createElement("script");
      script.id = "la_x2s6df8d";
      script.async = true;
      script.src = "https://enomo.ladesk.com/scripts/track.js"; // Замініть YOURURL на ваш URL від LiveAgent

      // Функція зворотного виклику після завантаження скрипта
      script.onload = () => {
        if (window.LiveAgent) {
          if (auth) {
            // console.log(email, firstName, lastName, phone);
            console.log(email, firstName, lastName, phone);
            window.LiveAgent.clearAllUserDetails();
            window.LiveAgent.setUserDetails();
            window.LiveAgent.setUserDetails(
              email,
              firstName && firstName,
              lastName && firstName,
              phone ? phone.replace(/[\+\s]/g, "") : ""
            );
            window.LiveAgent.addContactField("user_id", id);
          }
          const chatButton = window.LiveAgent.createButton(
            "z122wlnq",
            document.getElementById("chatButton")
          );
          chatButton.onCloseCallBack = () => {
            setOpen(false);
          };
          setButton(chatButton);
        } else {
          console.error("LiveAgent not initialized");
        }
      };

      // Обробка помилок завантаження скрипта
      script.onerror = () => {
        console.error("Failed to load LiveAgent script");
      };

      // Додаємо скрипт до DOM
      document.body.appendChild(script);
    }

    // Створюємо елемент script

    // Очищення при демонтуванні компонента
  }, [open]);

  return null; // Компонент не рендерить нічого у DOM
};

export default LiveAgentChatWidget;
